import { ProductCategory } from "enums/product.enum";
import { FlowType, InboundMethod, ReceptionItemKind } from "enums/reception.enum";

export interface RepairOption {
    productCode: string;
    productName: string;
    quantity: number;
    unitPrice: number;
    unitCost: number;
    kind: ReceptionItemKind;
    category?: ProductCategory;
}

/** 백엔드 DTO와 1:1 매칭 */
export class ReceptionItemDTO {
    id: number;
    kind: ReceptionItemKind;
    courierOutboundDate?: string;
    courierInboundDate?: string;
    repairDate?: string;
    modelName?: string;
    manufactureMonth?: string;
    note?: string;
    inboundMethod?: InboundMethod | null;
    flow?: FlowType | null;
    dlvFee: number | null;
    dlvCompany?: string;
    options?: RepairOption[];
    // 계산된 필드들 (읽기 전용)
    totalQuantity: number;
    totalAmount: number;
    totalCost: number;
    summary: string;
}